import request from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartUpdateCommentResponse } from './multiCartMappers'

type UpdateCommentRequest = paths['/api/carts/multi-carts/{multiCartId}/comments/{commentId}']['put']['requestBody']['content']['application/json']
type UpdateCommentResponse = paths['/api/carts/multi-carts/{multiCartId}/comments/{commentId}']['put']['responses']['200']['content']['application/json']

export async function updateMultiCartComment(
  multiCartId: string,
  commentId: string,
  text: string,
): Promise<App.MultiCartComment> {
  return request.put<UpdateCommentResponse, UpdateCommentRequest>(
    `/api/carts/multi-carts/${multiCartId}/comments/${commentId}`,
    { text },
    { credentials: 'include' },
  ).then(mapMultiCartUpdateCommentResponse)
}
